// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as setPassengerDetailsOnwardReducer } from './setPassengerDetailsOnward';
import { reducer as setPassengerDetailsReturnReducer } from './setPassengerDetailsReturn';
import { reducer as setContactDetailsReducer } from './setContactDetails';
import { reducer as bookTicketReducer } from './bookTicket';
import { reducer as applyPromoCodeReducer } from './applyPromoCode';
import { reducer as checkCorporateDiscountReducer } from './checkCorporateDiscount';
import { reducer as getConveniosReducer } from './getConvenios';
import { reducer as setConveniosReducer } from './setConvenios';
import { reducer as RutError } from './setRutError';
import { reducer as NameError } from './setNameError';
import { reducer as lastNameError } from './setLastNameError';
import { reducer as confirmEmailError } from './setConfirmEmailError';
import { reducer as emailError } from './setEmailError';
import { reducer as mobileError } from './setMobileError';

const reducers = [
  setPassengerDetailsOnwardReducer,
  setPassengerDetailsReturnReducer,
  setContactDetailsReducer,
  bookTicketReducer,
  applyPromoCodeReducer,
  checkCorporateDiscountReducer,
  getConveniosReducer,
  setConveniosReducer,
  RutError,
  NameError,
  lastNameError,
  confirmEmailError,
  emailError,
  mobileError,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/redux/reducer.js